import styled from 'styled-components'

export const Applockbg = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(to bottom, #0b0c1e, #3c2940);
`
export const LockImage = styled.img`
  width: 90px;
  height: 90px;
`
export const Text = styled.p`
  font-family: Roboto;
  font-size: 17px;
  color: #ffffff;
`
export const Button = styled.button`
  background-color: #06b6d4;
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  border: none;
  outline: none;
  width: 110px;
  height: 35px;
  cursor: pointer;
  border-radius: 7px;
  margin-top: 50px;
`
